function StatusBadges({ children }) {
  return <div className="status-badges">{children}</div>;
}
export default StatusBadges;
